import {
    getMockupGenerationLogs,
    getMockupGenerationLogsAnalytics,
    getMockupGenerationLog,
} from '../../thunk/mockupGenerationLogs';

export default {
    [getMockupGenerationLogs.pending as any]: (state: any) => {
        state.status = 'loading';
        state.error = null;
    },
    [getMockupGenerationLogs.fulfilled as any]: (state: any, action: any) => {
        state.status = 'resolved';
        state.list = action.payload.result || [];
        state.queryParams = {
            ...action.meta.arg,
            page: +action.payload.page,
            limit: +action.payload.perPage,
            total: +action.payload.totalCount,
        };
    },
    [getMockupGenerationLogs.rejected as any]: (state: any, action: any) => {
        state.status = 'rejected';
        state.error = action.payload;
    },

    [getMockupGenerationLogsAnalytics.pending as any]: (state: any) => {
        state.analyticsStatus = 'loading';
        state.analyticsError = null;
    },
    [getMockupGenerationLogsAnalytics.fulfilled as any]: (state: any, action: any) => {
        state.analyticsStatus = 'resolved';
        state.analyticsRows = action.payload.rows || [];
        state.analyticsTotal = action.payload.totalCount || 0;
        state.analyticsTruncated = !!action.payload.truncated;
        state.analyticsParams = action.meta.arg;
    },
    [getMockupGenerationLogsAnalytics.rejected as any]: (state: any, action: any) => {
        state.analyticsStatus = 'rejected';
        state.analyticsError = action.payload;
    },

    [getMockupGenerationLog.pending as any]: (state: any) => {
        state.singleStatus = 'loading';
        state.singleError = null;
    },
    [getMockupGenerationLog.fulfilled as any]: (state: any, action: any) => {
        state.singleStatus = 'resolved';
        state.singleLog = action.payload;
    },
    [getMockupGenerationLog.rejected as any]: (state: any, action: any) => {
        state.singleStatus = 'rejected';
        state.singleError = action.payload;
    },
};
